/**
 * Tools Service
 * 
 * Phase 2-B: Session Cookie Authentication
 * - Custom axios instances now use withCredentials: true
 * - access-token header REMOVED - auth is via session cookie
 */

import axios from "axios";
import API from "../../api/api";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";

export const toolsServices = {
  getFaqs: async () => {
    return API.get(`get-faqs`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  getNews: async () => {
    return API.get(`all-news`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  getNewsById: async (newsId) => {
    return API.get(`get-news-article?newsId=${newsId}`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  getLeads: async (page, itemsPerPage) => {
    return API.get(`leads?page=${page}&perPage=${itemsPerPage}`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  searchLead: async (name, page, itemsPerPage) => {
    return API.get(`search-lead?name=${name}&page=${page}&perPage=${itemsPerPage}`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  updateLead: async (editFormData, leadId) => {
    return API.patch(`update-lead/${leadId}`, JSON.stringify(editFormData))
      .then((response) => response.data)
      .catch((error) => console.log(error.message));
  },
  getReplicaBanner: async () => {
    return API.get(`get-replica-banner`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  uploadReplicaBanner: async (files) => {
    const formData = new FormData();
    [...files].forEach((file, i) => {
      formData.append("file", file);
    });
    
    // Create a new Axios instance for FormData upload
    const customAxios = axios.create({
      baseURL: BASE_URL,
      withCredentials: true, // Required for session cookies
    });

    customAxios.defaults.headers.common["api-key"] =
      localStorage.getItem("api-key") || DEFAULT_KEY;
    // NOTE: access-token header REMOVED - auth is via session cookie
    customAxios.defaults.headers.common["Content-Type"] = "multipart/form-data";

    try {
      const response = await customAxios.post(
        `upload-replica-banner`,
        formData
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteReplicaBanner: async (body) => {
    return API.delete(`delete-replica-banner`, { data: JSON.stringify(body) })
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
  getDownloadMaterials: async () => {
    return API.get(`downloadable-material`)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },
};
